import { forwardRef, useState } from 'react'
import { InputProps } from './Input.types'
import { InputWrapper, StyledInput, IconWrapper } from './Input.styles'
import { Icon } from '../Icon'
import { IconButton } from '../IconButton'

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      size = 'medium',
      variant = 'default',
      error = false,
      fullWidth = false,
      leftIcon,
      rightIcon,
      className,
      type,
      disabled,
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false)
    const isPasswordInput = type === 'password'
    const inputType = isPasswordInput && showPassword ? 'text' : type
    return (
      <InputWrapper $fullWidth={fullWidth} className={className}>
        {leftIcon && (
          <IconWrapper $position="left" $size={size}>
            {leftIcon}
          </IconWrapper>
        )}
        <StyledInput
          ref={ref}
          type={inputType}
          $size={size}
          $variant={variant}
          $error={error}
          $hasLeftIcon={!!leftIcon}
          $hasRightIcon={!!rightIcon || isPasswordInput}
          disabled={disabled}
          {...props}
        />
        {(rightIcon || isPasswordInput) && (
          <IconWrapper
            $position="right"
            $size={size}
            $isClickable={isPasswordInput}
          >
            {isPasswordInput ? (
              <IconButton
                size="small"
                variant="default"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                type="button"
                disabled={disabled}
              >
                <Icon name={showPassword ? 'eye-off' : 'eye'} size={size} />
              </IconButton>
            ) : (
              rightIcon
            )}
          </IconWrapper>
        )}
      </InputWrapper>
    )
  }
)

Input.displayName = 'Input'
